"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _style = _interopRequireDefault(require("./style.css"));
var _helpers = require("./helpers.js");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var validate = function validate(values) {
  var errors = {};
  if (!values.title) {
    errors.title = 'Title is required';
  }
  return errors;
};
var SurveyModalContents = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function SurveyModalContents() {
    _classCallCheck(this, SurveyModalContents);
    return _callSuper(this, SurveyModalContents, arguments);
  }
  _inherits(SurveyModalContents, _React$Component);
  return _createClass(SurveyModalContents, [{
    key: "render",
    value: function render() {
      var assignmentProjectStr = this.props.assignmentProjectStr;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: this.props.initialValues,
        onSubmit: this.props.onSubmit,
        validate: validate,
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit,
            isSubmitting = _ref.isSubmitting;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, assignmentProjectStr && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].project
          }, assignmentProjectStr), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Title",
              tooltip: "This name is shown only to Quest Project Admins and not survey respondents."
            }),
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "subtitle",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Subtitle",
              tooltip: "This description is shown only to Quest Project Admins and not survey respondents."
            })
          }), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginBottom: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
            title: "Advanced Settings"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "isRequired",
            component: _cccisdFormik.CccisdToggle,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Required",
              tooltip: "When all required surveys are completed, the overall Quest will be marked as complete. Surveys are always played in order. Quest will still be accessible if non-required surveys are incomplete even when configured to not allow answer editing after submission."
            })
          }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            title: "Submit",
            isLoading: isSubmitting,
            onClick: handleSubmit
          })));
        }
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(SurveyModalContents, "propTypes", {
  assignmentProjectStr: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func.isRequired,
  initialValues: _propTypes["default"].object
});